import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Platform14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.61415 0.35688C6.85166 0.214373 7.14838 0.214373 7.38589 0.35688L12.3859 3.35688C12.8626 3.64293 12.8626 4.35707 12.3859 4.64312L10.9578 5.5L12.3859 6.35687C12.8626 6.64292 12.8626 7.35706 12.3859 7.64311L10.9578 8.49999L12.3859 9.35687C12.8626 9.64292 12.8626 10.3571 12.3859 10.6431L7.38589 13.6431C7.14838 13.7856 6.85166 13.7856 6.61415 13.6431L1.61415 10.6431C1.13741 10.3571 1.1374 9.64292 1.61415 9.35687L3.04229 8.49999L1.61415 7.64311C1.13741 7.35706 1.13741 6.64292 1.61415 6.35687L3.04228 5.5L1.61415 4.64312C1.13741 4.35707 1.13741 3.64293 1.61415 3.35688L6.61415 0.35688ZM4.50002 9.37463L3.45776 9.99999L7.00002 12.1253L10.5423 9.99999L9.50002 9.37463L7.38589 10.6431C7.14838 10.7856 6.85166 10.7856 6.61415 10.6431L4.50002 9.37463ZM7.38589 7.64312L9.50003 6.37464L10.5423 6.99999L7.00002 9.12535L3.45776 6.99999L4.50002 6.37464L6.61415 7.64312C6.85166 7.78563 7.14838 7.78563 7.38589 7.64312ZM3.45776 4L7.00002 6.12536L10.5423 4L7.00002 1.87464L3.45776 4Z'
      fill='currentColor'
    />
  </Svg>
);

Platform14.displayName = 'Platform14';
export default Platform14;
